import { FaList, FaThLarge } from "react-icons/fa";
import "../../styles/visualization/viewSwitcher.css";

const ViewSwitcher = ({ viewMode, setViewMode }) => {
  return (
    <div className="folder-view-switcher">
      <button
        className={`folder-view-btn ${viewMode === "list" ? "active" : ""}`}
        onClick={() => setViewMode("list")}
        title="List View"
      >
        <FaList />
      </button>

      <button
        className={`folder-view-btn ${viewMode === "grid" ? "active" : ""}`}
        onClick={() => setViewMode("grid")}
        title="Grid View"
      >
        <FaThLarge />
      </button>
    </div>
  );
};

export default ViewSwitcher;
